module.exports = __webpack_public_path__ + "static/media/profile-photo-resize.2c3504b6.jpg";